exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".employment-details .mainTitle{margin-bottom:30px}.employment-details .form-group legend{margin-bottom:15px;color:rgba(0,0,0,.8705882353)}.employment-details .form-group button{height:54px}.employment-details .nav-control{margin-top:15px;margin-bottom:65px}.employment-details .nav-control button{width:93px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/Quoters/LongTerm/steps/EmploymentDetails.scss
// module id = 8086
// module chunks = 13